import React from 'react';
import { SaveButtonStatus } from '../../../hooks/useSaveButtonStatus';
import { StyledSaveButton } from './SaveButton.styles';

interface SaveButtonProps {
    children: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
    status: SaveButtonStatus;
    className?: string;
}

const SaveButton: React.FC<SaveButtonProps> = ({ children, onClick, disabled = false, status, className }) => {
    const isDisabled = disabled || status === 'saving';
    const isSaved = status === 'saving' || status === 'saved-pending' || status === 'saved-confirmed';

    return (
        <StyledSaveButton className={className} disabled={isDisabled} status={status} onClick={onClick}>
            <span className="save-checkmark" aria-hidden="true">
                ✓
            </span>
            <span className="save-label">{isSaved ? 'Saved' : children}</span>
        </StyledSaveButton>
    );
};

export default SaveButton;
